import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { normalize, schema } from "normalizr";

import { showError } from "../../utils/sagasErrorHandler";

import { getConfigCiTestCasesStatusesRequest } from "./api";
import { configCiTestCasesStatusesSelector } from "./selectors";
import { getConfigCiTestCasesStatuses, setConfigCiTestCasesStatuses } from "./actions";

const configCiTestCasesStatusesSchema = new schema.Entity("config_ci_test_case_statuses", {}, { idAttribute: "code" });
const configCiTestCasesStatusesListSchema = new schema.Array(configCiTestCasesStatusesSchema);

export function* getConfigCiTestCasesStatusesWorker() {
    try {
        const { codes } = yield select(configCiTestCasesStatusesSelector);

        if(!codes.length){
            yield put(setConfigCiTestCasesStatuses({ isLoadingConfigCiTestCasesStatuses: true }));

            const { config_ci_test_case_statuses } = yield call(getConfigCiTestCasesStatusesRequest);
            const { result, entities } = normalize(config_ci_test_case_statuses, configCiTestCasesStatusesListSchema);

            yield put(setConfigCiTestCasesStatuses({
                isLoadingConfigCiTestCasesStatuses: false,
                configCiTestCasesStatuses: entities.config_ci_test_case_statuses,
                codes: result
            }));
        }
    } catch (error) {
        yield put(setConfigCiTestCasesStatuses({ isLoadingConfigCiTestCasesStatuses: false }));
        showError(error);
    }
}

export function* getConfigCiTestCasesStatusesSagas() {
    yield all([
        yield takeLatest(getConfigCiTestCasesStatuses, getConfigCiTestCasesStatusesWorker)
    ]);
}
